<template>
  <transition name="fade-slide" mode="out-in" appear>
    <section class="h-full w-full overflow-auto p-4" :style="contentStyle">
      <component :is="page" />
    </section>
  </transition>
</template>

<script setup lang="ts">
import type { CSSProperties, VNode } from 'vue';

defineProps<{
  page: VNode;
  contentStyle?: CSSProperties;
}>();
</script>

<style></style>
